import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-featuremappings',
  templateUrl: './featuremappings.component.html',
  styleUrls: ['./featuremappings.component.scss']
})
export class FeaturemappingsComponent implements OnInit {
  constructor(private service: ApifirstService,private translate: TranslateService) { }
  vehicleLine: any
  language: any
  displayName: any
  onselecting: boolean = false;
  showloadingfeaturemap: boolean = false;
  nodataerror: boolean = false;
  vehList: any = [];
  displayID: any = []
  listOftwoelementsVehicles: any = [];
  listOfsingleVehicle: any = [];
  featureDeliverMapList: any = [];
  modelnamelist: any = [];
  upid: any;
  upvltype: any;
  upvlcode: any;
  upcodetype: any;
  upcodeValue: any;
  updeliverableId: any;
  updeliverableType: any;
  updisplayName: any;
  uplanguageCode: any;
  upcountryCode: any;
  upcreatedTimestamp: any;
  upupdatedTimestamp: any;
  tokenObj: any

  ngOnInit(): void {
    this.vehicleLine = 'None';
    this.displayName = 0;
    this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
      console.log(this.tokenObj,"TokenObj")
    })
    this.language = this.tokenObj.language.toLowerCase()
    this.service.getVehicleLines().subscribe((data) => {
      this.listOftwoelementsVehicles = data
      for (let index in this.listOftwoelementsVehicles) {
        this.listOfsingleVehicle = this.listOftwoelementsVehicles[index]
        this.vehList.push(this.listOfsingleVehicle[0] + "-" + this.listOfsingleVehicle[1]);
      }
    })
  }
  onSetVehLang() {
    this.showloadingfeaturemap = true;
    if (this.vehicleLine == 'None') {
      this.onselecting = false;
      this.showloadingfeaturemap = false;
      this.nodataerror = false;
    }
    else {
      this.onselecting = true;
    }
    let splitVehiclename = this.vehicleLine.split('-')
    let req = {
      "vehicleLineType": splitVehiclename[0],
      "vehicleLineCode": splitVehiclename[1],
      "language": this.language
    }
    if (this.onselecting) {
      this.service.featureDeliverList(req).subscribe((data) => {
        this.showloadingfeaturemap = false;
        this.featureDeliverMapList = data.featureDeliverableMapping
        this.modelnamelist = data.modelnamelist
        for (let i of this.featureDeliverMapList) {
          this.displayID.push(i.displayName)
        }
        if (this.featureDeliverMapList.length == 0) {
          this.nodataerror = true;
        }
        else {
          this.nodataerror = false;
        }
      })
    }
  }
  onSelectDispName(displayname: any,index:any) {
    this.displayID[index] = displayname
  }
  onClickOfUpdate(id:any) {
    for (let index in this.featureDeliverMapList) {
      if (id == this.featureDeliverMapList[index].id) {
        this.upid = this.featureDeliverMapList[index].id;
        this.upvltype = this.featureDeliverMapList[index].vltype;
        this.upvlcode = this.featureDeliverMapList[index].vlcode;
        this.upcodetype = this.featureDeliverMapList[index].codetype;
        this.upcodeValue = this.featureDeliverMapList[index].codeValue;
        this.updeliverableId = this.featureDeliverMapList[index].deliverableId;
        this.updeliverableType = this.featureDeliverMapList[index].deliverableType;
        this.updisplayName = this.displayID[index];
        this.uplanguageCode = this.featureDeliverMapList[index].languageCode;
        this.upcountryCode = this.featureDeliverMapList[index].countryCode;
        this.upcreatedTimestamp = this.featureDeliverMapList[index].createdTimestamp;
        this.upupdatedTimestamp = this.featureDeliverMapList[index].updatedTimestamp;
      }
    }
    let req = {
      "id": this.upid,
      "vltype": this.upvltype,
      "vlcode": this.upvlcode,
      "codetype": this.upcodetype,
      "codeValue": this.upcodeValue,
      "deliverableId": this.updeliverableId,
      "deliverableType": this.updeliverableType,
      "displayName": this.updisplayName,
      "languageCode": this.uplanguageCode,
      "countryCode": this.upcountryCode,
      "createdTimestamp": this.upcreatedTimestamp,
      "updatedTimestamp": this.upupdatedTimestamp,
    }
    this.service.updateDispName(req).subscribe((data) => {
    })
  }
}
